// directDebitRunButton.js - Adds a button to the direct debit execute page
// Uses shared Lux_findTopLevelStateIn from consts/reactStateFinder.js

let Lux_DirectDebitRun_observer = null

/**
 * Extract direct debits from the table's React state.
 * Same structure as payments: value.current.value contains the list.
 */
function Lux_extractDirectDebitsFromState() {
  const stateMatch = Lux_findTopLevelStateIn('#DirectDebitOverview', 'sequenceType')

  if (!stateMatch) {
    console.error('Lux Inject: Could not find direct debits state')
    return null
  }

  let items = null
  const value = stateMatch.value

  if (value?.current?.hasValue && Array.isArray(value.current.value)) {
    items = value.current.value
  } else if (value?.current?.value && Array.isArray(value.current.value)) {
    items = value.current.value
  } else if (value?.current && Array.isArray(value.current)) {
    items = value.current
  } else if (Array.isArray(value)) {
    items = value.filter(item => item && (item.sequenceType || item.executionDate))
  } else if (value?.dataSource && Array.isArray(value.dataSource)) {
    items = value.dataSource
  } else if (value?.data && Array.isArray(value.data)) {
    items = value.data
  } else if (value?.content && Array.isArray(value.content)) {
    items = value.content
  } else {
    for (const key of Object.keys(value || {})) {
      const prop = value[key]
      if (Array.isArray(prop) && prop.length > 0 && (prop[0]?.sequenceType || prop[0]?.executionDate)) {
        items = prop
        break
      }
    }
  }

  if (items) {
    items = items.filter(
      item => item && (item.sequenceType || item.executionDate || item.amount || item.counterpartIban)
    )
  }

  return items
}

function Lux_setDirectDebitButtonLoading(button, isLoading) {
  if (isLoading) {
    button.disabled = true
    button.dataset.originalText = button.textContent
    button.innerHTML = `
      <span style="display: inline-flex; align-items: center; gap: 6px;">
        <span class="lux-spinner" style="
          display: inline-block;
          width: 14px;
          height: 14px;
          border: 2px solid rgba(0, 0, 0, 0.2);
          border-top-color: #1890ff;
          border-radius: 50%;
          animation: lux-spin 0.8s linear infinite;
        "></span>
        Wird erstellt...
      </span>
    `
    if (!document.getElementById('lux-spinner-styles')) {
      const style = document.createElement('style')
      style.id = 'lux-spinner-styles'
      style.textContent = `
        @keyframes lux-spin {
          to { transform: rotate(360deg); }
        }
      `
      document.head.appendChild(style)
    }
  } else {
    button.disabled = false
    button.textContent = button.dataset.originalText || 'Herunterladen'
  }
}

function Lux_initializeDirectDebitRunButton() {
  const anchorSelector = '#DirectDebitOverview > div > div.section-content > div > div.ant-col.ant-col-12'
  const buttonId = 'lux-direct-debit-run-btn'

  if (Lux_DirectDebitRun_observer) {
    Lux_DirectDebitRun_observer.disconnect()
    Lux_DirectDebitRun_observer = null
  }

  const injectButton = (anchorElement) => {
    if (document.getElementById(buttonId)) {
      return
    }

    const clonedCol = anchorElement.cloneNode(true)
    clonedCol.id = buttonId + '-container'

    const labelElement = clonedCol.querySelector('.ant-col.ant-form-item-label')
    if (labelElement) {
      const labelText = labelElement.querySelector('label')
      if (labelText) {
        labelText.textContent = 'Lastschriftübersicht herunterladen'
      }
    }

    const controlElement = clonedCol.querySelector('.ant-col.ant-form-item-control')
    if (controlElement) {
      const directDebitRunButton = document.createElement('button')
      directDebitRunButton.type = 'button'
      directDebitRunButton.className = 'ant-btn ant-btn-primary Button'
      directDebitRunButton.style.height = '40px'
      directDebitRunButton.id = buttonId
      directDebitRunButton.textContent = 'Herunterladen'
      directDebitRunButton.disabled = true
      directDebitRunButton.style.opacity = '0.5'
      directDebitRunButton.style.cursor = 'not-allowed'

      let checkInterval = null
      const checkForDirectDebits = () => {
        const directDebits = Lux_extractDirectDebitsFromState()
        if (directDebits && directDebits.length > 0) {
          directDebitRunButton.disabled = false
          directDebitRunButton.style.opacity = '1'
          directDebitRunButton.style.cursor = 'pointer'
          directDebitRunButton.textContent = `Herunterladen (${directDebits.length})`
          console.log(`Lux Inject: Found ${directDebits.length} direct debits, button enabled`)
          if (checkInterval) {
            clearInterval(checkInterval)
            checkInterval = null
          }
        } else {
          directDebitRunButton.disabled = true
          directDebitRunButton.style.opacity = '0.5'
          directDebitRunButton.style.cursor = 'not-allowed'
          directDebitRunButton.textContent = 'Herunterladen'
        }
      }

      setTimeout(checkForDirectDebits, 1000)
      checkInterval = setInterval(checkForDirectDebits, 2000)

      const cleanupObserver = new MutationObserver(() => {
        if (!document.contains(directDebitRunButton)) {
          clearInterval(checkInterval)
          cleanupObserver.disconnect()
        }
      })
      cleanupObserver.observe(document.body, { childList: true, subtree: true })

      directDebitRunButton.addEventListener('click', async () => {
        console.log('Lux Inject: Direct Debit Run Button clicked')

        Lux_setDirectDebitButtonLoading(directDebitRunButton, true)

        try {
          const directDebits = Lux_extractDirectDebitsFromState()

          if (!directDebits || directDebits.length === 0) {
            alert('Keine Lastschriften gefunden. Bitte stellen Sie sicher, dass die Tabelle Daten enthält.')
            Lux_setDirectDebitButtonLoading(directDebitRunButton, false)
            return
          }

          console.log(`Lux Inject: Found ${directDebits.length} direct debits`)

          const authData = localStorage.getItem('auth')
          if (!authData) {
            throw new Error('Authentifizierungsdaten nicht gefunden')
          }
          const token = JSON.parse(authData).token
          if (!token) {
            throw new Error('Authentifizierungstoken nicht gefunden')
          }

          const response = await fetch('/api/reports/direct-debit-overview', {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ directDebits })
          })

          if (!response.ok) {
            throw new Error(`HTTP-Fehler: ${response.status}`)
          }

          const blob = await response.blob()
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = `lastschriftuebersicht_${new Date().toISOString().split('T')[0]}.pdf`
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
          a.remove()

          console.log('Lux Inject: Direct debit PDF downloaded successfully')
        } catch (error) {
          console.error('Lux Inject: Error generating direct debit overview:', error)
          alert('Fehler beim Erstellen der Lastschriftübersicht: ' + error.message)
        }

        Lux_setDirectDebitButtonLoading(directDebitRunButton, false)
      })

      controlElement.parentNode.replaceChild(directDebitRunButton, controlElement)
    }

    anchorElement.parentNode.insertBefore(clonedCol, anchorElement.nextSibling)
  }

  const anchorElement = document.querySelector(anchorSelector)
  if (anchorElement) {
    injectButton(anchorElement)
    return
  }

  Lux_DirectDebitRun_observer = new MutationObserver((mutationsList, observer) => {
    const anchorElement = document.querySelector(anchorSelector)
    if (anchorElement) {
      observer.disconnect()
      Lux_DirectDebitRun_observer = null
      injectButton(anchorElement)
    }
  })

  Lux_DirectDebitRun_observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}
